
      var isNative = location.protocol === 'capacitor:' ||
                     location.protocol === 'file:' ||
                     /capacitor/i.test(navigator.userAgent) ||
                     (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
      if (isNative || (location.pathname !== '/' && location.pathname !== '/index.html')) {
        import('/src/main.tsx');
      }
    